import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Options } from './options.js';
import Utils from "./utils.js";

const Animations = (() => {


    const initialize = () => {

        if (!Options.animations.disabled) {
            console.log('init animations');

            // TODO: 


            // 1. get all modules/elements with data-animate attribute
            // 2. initialize them by the specified animations

            gsap.registerPlugin(ScrollTrigger);


            addPins();

            reveal.init();
            translateX.init();
            translateY.init();

        } else {
            console.debug('Animations disabled');
        }

    };


    /**
     * 
     * Default animated element is the element itself which holds the data-animate attribute.
     * In addition animated elements can be set by defining the data-animate-elements. 
     * Its value is a are comma separated list of selectors eg. data-animate-elements=".text, .title" 
     * 
     * @param {HTMLNode} element 
     */
    const getAnimateElements = element => {
        // default animated element is the one the data-animate attribute is defined
        let animatedElements = Array.from([element]);

        if (element.dataset[`animateElements`]) {
            const dataElements = element.querySelectorAll((element.dataset[`animateElements`]));

            if (dataElements.length) {
                animatedElements = dataElements;
            }
        }

        return animatedElements;
    };

    const getAnimationElements = (element, animationName) => {
        // default animated element is the one the data-animate attribute is defined
        let animatedElements = Array.from([element]);

        // dataset needs camelCase so animation name needs to be converted

        let animationNameCamelCase = animations.name.slice(1).toUpperCase();


        if (element.dataset[`animate${animationNameCamelCase}`]) {
            const dataElements = element.querySelectorAll((element.dataset[`animate${animationNameCamelCase}`]));

            if (dataElements.length) {
                animatedElements = dataElements;
            }
        }

        return animatedElements;
    };

    const getAnimateTweenOptions = element => {

        let dataOptions = element.dataset[`animateTweenOptions`];

        if (dataOptions?.length) {
            return JSON.parse(dataOptions);
        }

        return;
    };

    const getAnimatePinOptions = element => {

        let dataOptions = element.dataset[`animatePin`];

        if (dataOptions?.length) {
            return JSON.parse(dataOptions);
        }

        return;
    };

    const getAnimateOptions = (element, animationName) => {

        let animationNameCamelCase = Utils.capitalize(animationName);
        let dataOptions = element.dataset[`animate${animationNameCamelCase}`];

        if (dataOptions?.length) {
            return JSON.parse(dataOptions);
        }

        return;
    };


    const addPins = () => {

        // get elements with data-animate-pin

        const elements = document.querySelectorAll('[data-animate-pin]');

        if (!elements.length) return;

        elements.forEach((el) => {

            //let dataOptions = getAnimatePinOptions(el);
            let dataOptions = getAnimateOptions(el, "pin");
            let pinOptions = {
                trigger: el
            };

            if (dataOptions) {
                pinOptions = { ...pinOptions, ...dataOptions };
            }

            // TODO: move out
            createPin(pinOptions);
        });

    };


    /**
     * create a ScrollTrigger for pinning
     * 
     * @param {*} param0 
     * @returns 
     */
    const createPin = ({
        trigger,
        start = 'top top',
        end = '+=150%',
        markers = Options.animations.markers,
        id= trigger?.id,
        animation = undefined
    }) => {

        const options = {
            trigger,
            pin: true,
            pinSpacing: true,
            start,
            end,
            markers,
            id: id,
            animation,
            onUpdate: (self) => {
                /* console.debug(self.progress) */
            }
        };

        console.debug(`pin options: `, options);

        return ScrollTrigger.create(options);
    }


    const reveal = {

        ANIMATION_NAME: "reveal-content",

        init() {

            const SELECTOR_ATTRIBUTE = `[data-animate*=${this.ANIMATION_NAME}]`;
            const modules = document.querySelectorAll(SELECTOR_ATTRIBUTE);

            if (!modules.length) return;


            modules.forEach((module) => {
                console.debug(`initialize animation: ${this.ANIMATION_NAME}`);
                this.animate(module);
            });


        },

        animate(element) {

            // default animated element is the one the data-animate attribute is defined
            let animatedElements = getAnimateElements(element);

            // default options
            let tweenOptions = {
                autoAlpha: 1,
                duration: 0.5,
                ease: "power3.inOut",

            }

            let tweenDataOptions = getAnimateTweenOptions(element);
            if (tweenDataOptions) {

                tweenOptions = { ...tweenOptions, ...tweenDataOptions };
            }


            /* let tween = gsap.to(animatedElements, tweenOptions); */
            let tween = gsap.fromTo(animatedElements, { autoAlpha: 0 }, tweenOptions);

            let st = ScrollTrigger.create({
                trigger: element,
                start: "top center",
                animation: tween,
                markers: Options.animations.markers
            });


            let pinDataOptions = getAnimatePinOptions(element);
            let pinOptions = {
                trigger: element
            };

            if (pinDataOptions) {
                pinOptions = { ...pinOptions, ...pinDataOptions };
            }

            // TODO: move out
            /* createPin(pinOptions); */

        }

    };

    const translateX = {

        ANIMATION_NAME: "translateX-content",

        init() {

            const SELECTOR_ATTRIBUTE = `[data-animate*=${this.ANIMATION_NAME}]`;
            const modules = document.querySelectorAll(SELECTOR_ATTRIBUTE);

            if (!modules.length) return;


            modules.forEach((module) => {
                console.debug(`initialize animation: ${this.ANIMATION_NAME}`);
                this.animate(module);
            });


        },

        animate(element) {

            // default animated element is the one the data-animate attribute is defined
            let animatedElements = getAnimateElements(element);

            // default options
            let tweenOptions = {
                xPercent: 100,
                duration: 0.5,
                ease: "power3.in"
            };

            let tweenDataOptions = getAnimateTweenOptions(element);
            if (tweenDataOptions) {

                tweenOptions = { ...tweenOptions, ...tweenDataOptions };
            }

            let inversValue = tweenOptions.xPercent * (-1);
            animatedElements.forEach(ael => ael.style.transform = `translateX(${inversValue}%)`);

            let tween = gsap.to(animatedElements, tweenOptions);

            let st = ScrollTrigger.create({
                trigger: element,
                start: "top 75%",
                animation: tween,
                once: true,
                markers: Options.animations.markers
            });

        }

    };

    const translateY = {

        ANIMATION_NAME: "translateY-content",

        init() {

            const SELECTOR_ATTRIBUTE = `[data-animate*=${this.ANIMATION_NAME}]`;
            const modules = document.querySelectorAll(SELECTOR_ATTRIBUTE);

            if (!modules.length) return;


            modules.forEach((module) => {
                console.debug(`initialize animation: ${this.ANIMATION_NAME}`);
                this.animate(module);
            });


        },

        animate(element) {

            // default animated element is the one the data-animate attribute is defined
            let animatedElements = getAnimateElements(element);

            // default options
            let tweenOptions = {
                yPercent: 0,
                duration: 0.5,
                ease: "power3.in"
            };

            let tweenDataOptions = getAnimateTweenOptions(element);
            if (tweenDataOptions) {

                tweenOptions = { ...tweenOptions, ...tweenDataOptions };
            }

            let inversValue = tweenOptions.yPercent * (-1);
            animatedElements.forEach(ael => ael.style.transform = `translateY(${inversValue}%)`);

            let tween = gsap.to(animatedElements, tweenOptions);

            let st = ScrollTrigger.create({
                trigger: element,
                start: "top 50%",
                animation: tween,
                once: true,
                markers: Options.animations.markers
            });

        }

    }

    // refresh scrollTrigger instances
    const refresh = () => {
            ScrollTrigger.refresh();
    };

    /**
     * avoiding flash of unstyled content
     * module is set visibility: hidden per css and is revealed by gsap
     * 
     * 
     * @param {*} element 
     * @returns 
     */
    const fouc = (element) => {

        if (!element) return;

        // animation timeline
        gsap.fromTo(element,
            { autoAlpha: 0, y: 0 },
            { autoAlpha: 1, y: 0, ease: "power2.in", duration: 0.2, once: true },
        )

    };

    const revealElements = (elements, optsFrom = {}, optsTo = {}) => {
        gsap.killTweensOf(elements)
        return gsap.fromTo(elements,
            {
                autoAlpha: 0,
                y: 30,
                ...optsFrom
            },
            {
                autoAlpha: 1,
                y: 0,
                duration: 0.5,
                ease: 'ease.in',
                ...optsTo
            })
    };

    
    const hideElements = (elements, optsFrom = {}, optsTo = {}) => {
        gsap.killTweensOf(elements);
        return gsap.fromTo(elements,
            { autoAlpha: 1, y: 0, ...optsFrom },
            {
                autoAlpha: 0,
                y: 30,
                duration: 0.3,
                ease: 'ease.out',
                ...optsTo
            })
    };

    const heartbeatElements = (elements, opts = {}) => {

        // tween defaults
        const defaults = {

            duration: 0.75,
            ease: 'power1.out', // sine, circ, ease, power1,back.out(1.7)
            scaleTo: 1.08,
            ransformOrigin: "center center"
        }

        gsap.killTweensOf(elements);
          return gsap.timeline({
            delay: 0,
            repeat: 0,
            repeatDelay: 0,
            ...opts

          })
            .to(elements, { scale: defaults.scaleTo,  duration: defaults.duration, transformOrigin: defaults.transformOrigin, ease: defaults.ease,/*  delay: 0.1 */ })
            .to(elements, { scale: 1, duration: defaults.duration, transformOrigin: defaults.transformOrigin, ease: defaults.ease, /* delay: 0.1 */ })
            /* .to(elements, { scale: defaults.scaleTo, duration: defaults.duration, transformOrigin: defaults.transformOrigin,  ease: defaults.ease })
            .to(elements, { scale: 1, duration: defaults.duration, transformOrigin: defaults.transformOrigin, ease: defaults.ease }); */
        };

    return {
        initialize,
        createPin,
        refresh,
        fouc,
        revealElements,
        hideElements,
        heartbeatElements        
    };

})();


export default Animations;